<template>
  <PageLoader :loading="loading">
    <ShopPage />
  </PageLoader>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ShopPage from "@/components/pages/shop";
import PageLoader from "@/components/pages/PageLoader";
import { useShopProfileStore } from "@/stores/shop-profile";
import { salesApi } from "@/services/sales-api";
import { TabPageType } from "@/components/pages/shop/lib";

export default defineComponent({
  components: { ShopPage, PageLoader },
  setup() {
    definePageMeta({
      disableHeaderStick: true,
    });

    const route = useRoute();
    const store = useShopProfileStore();
    const sales = salesApi();

    const _view = String(route.query.view) as TabPageType;
    const view =
      _view && Object.values(TabPageType).includes(_view) ? _view : null;

    if (view) {
      store.viewMode = view;
    }

    const {
      loading,
      onResult,
      onError,
      handle: get,
    } = observeAsync(sales.profile.store);

    const handle = String(route.params.handle);
    store.handle = handle;

    onResult(store.update);
    onError(() => {
      //
    });

    onMounted(() =>
      get(handle, {
        // with: view
        //   ? match(view, {
        //       [TabPageType.Shop]: "products",
        //       [TabPageType.Services]: "services",
        //       [TabPageType.Events]: "events",
        //       default: undefined,
        //     })
        //   : ["products", "services", "events", "stats"],
        with: ["products", "services", "events", "stats"],
      })
    );

    return {
      loading,
    };
  },
});
</script>
